import { jsxs, jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';
import Button from '../V2/Button/Button.js';
import Logo from '../Icons/Logo.js';

/**
 * Errore generico.
 */
function ErrorPage({ image, title, message, actionLabel = undefined, onActionClick = undefined, asPage = true, }) {
    const className = cns('error-page', {
        'error-page--inside': !asPage,
    });
    return (jsxs("div", { className: className, children: [jsxs("div", { className: "error-page__main error-page__main--error-page", children: [jsx("div", { className: "error-page__empty" }), image, jsxs("div", { className: "error-page__message", children: [jsx("p", { className: "error-page__message-title", children: title }), jsx("p", { className: "error-page__message-message", children: message }), actionLabel && onActionClick
                                && (jsx("div", { className: "error-page__message-action", children: jsx(Button, { primary: true, emphasis: Button.Emphasis.HIGH, onClick: onActionClick, children: actionLabel }) }))] }), jsx("div", { className: "error-page__empty" })] }), asPage && (jsx("div", { className: "error-page__fixedfooter", children: jsx("div", { className: "error-page__footer", children: jsx(Logo, { className: "error-page__logo error-page__logo--unexpected" }) }) }))] }));
}

export { ErrorPage as default };
